import React from 'react'
import { Modal, Button } from 'react-bootstrap-v5'
import Dropdown from './Dropdown'

interface Field {
  label: string
  key: string
  type: string //'text' / 'dropdown'
  options?: { id: number; name: string }[]
}

interface NewPostCode {
  [key: string]: string | null
}

interface NewPostCodeModalProps {
  isOpen: boolean
  onClose: () => void
  onSave: (newPostCode: NewPostCode) => void
  fields: Field[]
  initialValues?: NewPostCode
}

const NewPostCodeModal: React.FC<NewPostCodeModalProps> = ({ isOpen, onClose, onSave, fields, initialValues  }) => {
  const [newPostCode, setNewPostCode] = React.useState<NewPostCode>(
    fields?.reduce((acc, field) => {
      acc[field.key] = field.type === 'dropdown' ? '' : null
      return acc
    }, {} as NewPostCode) || {}
  )

  const isUpdate = initialValues !== null && initialValues !== undefined && Object.keys(initialValues).length > 0

  React.useEffect(() => {
    if (isOpen && initialValues) {
      setNewPostCode((prevPostCode) => ({
        ...prevPostCode,
        ...fields.reduce((acc, field) => {
          if (field.type === 'dropdown' && initialValues[`${field.key}Id`]) {
            // Use the existing id value for dropdown fields
            acc[field.key] = initialValues[`${field.key}Id`]
          } else {
            acc[field.key] = initialValues[field.key] || null
          }
          return acc
        }, {} as NewPostCode),
      }))
    }

  }, [isOpen, initialValues, fields])
  
  const handleSave = () => {
    onSave(newPostCode)
    onClose()
  }

  const handleFieldChange = (key: string, value: string) => {
    setNewPostCode((prevPostCode) => ({
      ...prevPostCode,
      [key]: value,
    }))
  }

  React.useEffect(() => {
    if (!isOpen) {
      setNewPostCode(
        fields.reduce((acc, field) => {
          acc[field.key] = field.type === 'dropdown' && field.options ? '' : null
          return acc
        }, {} as NewPostCode)
      )
    }
  }, [isOpen, fields])
  
  return (
    <Modal show={isOpen} onHide={onClose}>
    <Modal.Header>
      <Modal.Title>{isUpdate ? 'Update Post Code' : 'New Post Code'}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className="row">
        {fields.map((field, index) => (
          <div
            key={field.key}
            className="col-12"
            style={{
              marginBottom: index === 0 ? '0' : '10px',
            }}
          >
            <label style={{ display: 'block', textTransform: 'uppercase', fontWeight: 'bold' }}>
              {field.label}
            </label>
            {field.type === 'dropdown' && field.options ? (
              <Dropdown
                options={field.options}
                value={newPostCode[field.key] as string}
                onChange={(value) => handleFieldChange(field.key, value)}
              />
            ) : field.type === 'number' ? (
              <input
                type="number"
                className="form-control"
                value={newPostCode[field.key] || ''}
                onChange={(e) => handleFieldChange(field.key, e.target.value)}
                style={{ width: '100%', border: '1px solid #bbb' }}
                maxLength={99}
              />
            ) : (
              <input
                type="text"
                className='form-control'
                value={newPostCode[field.key] || ''}
                onChange={(e) => handleFieldChange(field.key, e.target.value)}
                style={{ width: '100%', border: '1px solid #bbb' }}
                maxLength={99}
              />
            )}
          </div>
        ))}
      </div>
    </Modal.Body>
    <Modal.Footer style={{ justifyContent: 'center' }}>
      <Button variant="primary" onClick={handleSave} 
        disabled={Object.values(newPostCode).some((value) => value === null ||  `${value}`?.trim() === '')}>
          <i className='fa fa-save text-dark'></i> SAVE
      </Button>

      <Button variant="secondary" onClick={onClose}>
        Cancel
      </Button>
    </Modal.Footer>
  </Modal>
  )
}

export default NewPostCodeModal
